export const types = {
    login : '[AUTH] Login',
    logout : '[AUTH] Logout',

    // HTTP REQUESTERS
    post : 'POST',
    put : 'PUT',
    get : 'GET',
    delete : 'DELETE',

    // Controladores
    carteras : 'Carteras',
    iniciativas : 'Iniciativas',
    recopilacionAntecedentes : 'RecopilacionAntecedentes'

}